import { Reader as ReaderContainer } from '@/components/Reader/containers/ReaderContainer';

export const useHasTOC = (limit = 3) => {
  const { tableOfContents } = ReaderContainer.useContainer();

  return !!tableOfContents.value && tableOfContents.value.length >= limit;
};
